module.exports = __webpack_public_path__ + "static/img/illust_4_mk.b11e3aa4.svg";